import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit de Mezclas, Reacciones y Energía',
  desc: 'Ejercicios guiados para activar práctica desde la semana 1. Abrís la ficha y la clase funciona.',
  value: '4.500',
  color: 'bg-blue-600'
}, {
  num: '02',
  title: 'Conceptos Fundamentales — Nivelación Express',
  desc: 'Base clara para nivelar grupos heterogéneos. Ideal para diagnóstico de inicio de año.',
  value: '3.500',
  color: 'bg-teal-600'
}, {
  num: '03',
  title: 'Química Orgánica y Vida Cotidiana',
  desc: 'Ejemplos reales para enganchar a los que odian la química. Conecta contenidos con la vida real de tus alumnos.',
  value: '3.500',
  color: 'bg-amber-600'
}, {
  num: '04',
  title: 'Cuaderno Interactivo de Actividad',
  desc: 'Registros y experiencias listas para aplicar en el aula o de manera virtual.',
  value: '3.000',
  color: 'bg-purple-600'
}, {
  num: '05',
  title: 'Puente Química General y Orgánica',
  desc: 'Secuencia completa para conectar contenidos entre años sin baches conceptuales.',
  value: '3.500',
  color: 'bg-red-600'
}, {
  num: '06',
  title: 'Planilla de Seguimiento Docente',
  desc: 'Rúbrica + criterios de evaluación para registrar el progreso de cada alumno sin improvisar.',
  value: '2.500',
  color: 'bg-indigo-600'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-brand-dark text-white" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-4xl md:text-6xl font-black text-brand-orange mb-6 uppercase tracking-tight" data-id="element-22">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-2xl font-bold text-gray-300 mb-4" data-id="element-23">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <div className="inline-block bg-brand-green text-white text-2xl font-black px-8 py-3 rounded-full animate-pulse-fast shadow-[0_0_20px_rgba(0,178,122,0.5)]" data-id="element-24">
            🎁 GRATIS por el día de hoy
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-25">
          {bonuses.map((b, i) => <div key={i} className="bg-[#252542] rounded-2xl overflow-hidden border border-gray-700 shadow-2xl flex flex-col h-full" data-id="element-26">
              {/* 1080x1080 Aspect Ratio Image Placeholder */}
              <div className={`aspect-square ${b.color} p-8 flex flex-col items-center justify-center text-center relative`} data-id="element-27">
                <div className="absolute top-4 left-4 bg-white text-black font-black text-2xl px-4 py-1 rounded-lg" data-id="element-28">
                  {b.num}
                </div>
                <h3 className="text-3xl md:text-4xl font-black text-white leading-tight drop-shadow-md" data-id="element-29">
                  BONO {parseInt(b.num)}
                </h3>
                <p className="text-xl font-bold mt-4 text-white/90 drop-shadow-md px-4" data-id="element-30">
                  {b.title}
                </p>
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-31">
                <div className="flex items-center gap-2 mb-4" data-id="element-32">
                  <span className="text-2xl" data-id="element-33">🎁</span>
                  <h4 className="text-xl font-bold text-brand-orange" data-id="element-34">
                    BONO {parseInt(b.num)}
                  </h4>
                </div>
                <h5 className="text-2xl font-bold mb-4" data-id="element-35">{b.title}</h5>
                <p className="text-gray-300 text-lg mb-8 flex-grow" data-id="element-36">{b.desc}</p>

                <div className="mt-auto pt-6 border-t border-gray-700 flex justify-between items-center" data-id="element-37">
                  <div className="text-gray-400 font-medium" data-id="element-38">
                    Valor: <span className="line-through" data-id="element-39">${b.value}</span>
                  </div>
                  <div className="text-brand-green font-black text-2xl" data-id="element-40">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-[#252542] border-2 border-brand-orange rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-41">
          <p className="text-2xl text-gray-300 mb-2" data-id="element-42">
            Valor total de los 6 Bonos:{' '}
            <span className="line-through" data-id="element-43">$20.500 ARS</span>
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-green" data-id="element-44">
            🎁 GRATIS — Solo con tu compra. Siempre.
          </p>
        </div>
      </div>
    </section>;
}